export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/debuggerWorker.16cda763.worker.js");
}
